<template>
  <div class="sctz38Div" id="sctz38Div">
    <div class="main-layout">
      <!-- 左侧24% A区 -->
      <div class="left-section">
        <div class="sky-garden">
          <svg class="cross-svg" viewBox="0 0 100 100" preserveAspectRatio="none">
            <line x1="0" y1="0" x2="100" y2="100" stroke="#000" stroke-width="0.2" />
            <line x1="100" y1="0" x2="0" y2="100" stroke="#000" stroke-width="0.2" />
          </svg>
        </div>
        <div class="caiwu">
          <div style="width: 26rem;" :class="checkList.includes('A') ? 'Aqu' : 'Aqu-hidden'">
            <seat-tab class="flex-row margin-bottom-1td" :seatList="sData.A1" classTd="common_td" />
          </div>
          <div style="width: 26rem;" :class="checkList.includes('A') ? 'Aqu' : 'Aqu-hidden'">
            <seat-tab class="flex-row margin-bottom-1td" :seatList="sData.A2" classTd="common_td" />
          </div>
          <div style="width: 26rem;" :class="checkList.includes('A') ? 'Aqu' : 'Aqu-hidden'">
            <seat-tab class="flex-row margin-bottom-1td" :seatList="sData.A3" classTd="common_td" />
          </div>
          <div style="width: 21rem;" :class="checkList.includes('A') ? 'Aqu' : 'Aqu-hidden'">
            <seat-tab class="flex-row" :seatList="sData.A4_1" classTd="common_td" />
          </div>
        </div>
        <div style="width: 30rem;" :class="checkList.includes('A') ? 'Aqu' : 'Aqu-hidden'">
          <seat-tab class="flex-row margin-bottom-1td" :seatList="sData.A4_2" classTd="common_td" />
        </div>
        <div style="width: 30rem;" :class="checkList.includes('A') ? 'Aqu' : 'Aqu-hidden'">
          <seat-tab class="flex-row margin-bottom-1td" :seatList="sData.A5" classTd="common_td" />
        </div>
        <div style="width: 30rem;" :class="checkList.includes('A') ? 'Aqu' : 'Aqu-hidden'">
          <seat-tab class="flex-row margin-bottom-1td" :seatList="sData.A6" classTd="common_td" />
        </div>
        <div style="width: 30rem;" :class="checkList.includes('A') ? 'Aqu' : 'Aqu-hidden'">
          <seat-tab class="flex-row margin-bottom-1td" :seatList="sData.A7" classTd="common_td" />
        </div>
        <div style="width: 30rem;" :class="checkList.includes('A') ? 'Aqu' : 'Aqu-hidden'">
          <seat-tab class="flex-row margin-bottom-1td" :seatList="sData.A8" classTd="common_td" />
        </div>
        <div style="width: 30rem;" :class="checkList.includes('A') ? 'Aqu' : 'Aqu-hidden'">
          <seat-tab class="flex-row margin-bottom-1td" :seatList="sData.A9" classTd="common_td" />
        </div>
        <div style="width: 30rem;" :class="checkList.includes('A') ? 'Aqu' : 'Aqu-hidden'">
          <seat-tab class="flex-row margin-bottom-1td" :seatList="sData.A10" classTd="common_td" />
        </div>
        <div style="width: 30rem;" :class="checkList.includes('A') ? 'Aqu' : 'Aqu-hidden'">
          <seat-tab class="flex-row" :seatList="sData.A11" classTd="common_td" />
        </div>
      </div>

      <!-- 右侧76% -->
      <div class="right-section">
        <!-- 右侧上部 C区 -->
        <div class="right-top-section">
          <!-- 茶水间、储物间、日内瓦 -->
          <div class="right-top-section-1">
            <img src="../images/tea.png" title="茶水间" style="width: 3rem;" />
            <span>茶水间</span>
          </div>
          <div class="right-top-section-2">
            <div class="storage-room">储物间</div>
            <div class="geneva-room">圣迭戈</div>
          </div>

          <!-- 第一组总监办小会议室 -->
          <div class="right-top-section-3">
            <div class="director-room">堪培拉</div>
            <div class="director-room">墨尔本</div>
            <div class="director-room">休斯顿</div>
          </div>
          <div class="right-top-section-4">
            <!-- C区座位第一列 -->
            <div class="c-seat-column" :class="checkList.includes('C') ? 'Cqu' : 'Cqu-hidden'">
              <div style="width: 10rem;margin-right: 3rem;">
                <seat-tab class="flex-row" style="justify-content: center;" :seatList="sData.C1" classTd="common_td" />
              </div>
            </div>

            <!-- 总监办 -->
            <div class="director-office-middle">
              总<br />监<br />办
            </div>

            <!-- C区座位第二列 -->
            <div class="c-seat-column" :class="checkList.includes('C') ? 'Cqu' : 'Cqu-hidden'">
              <div style="width: 10rem;margin-left: 3rem;">
                <seat-tab class="flex-row" style="justify-content: center;" :seatList="sData.C2" classTd="common_td" />
              </div>
            </div>
          </div>

          <!-- 第二组总监办小会议室 -->
          <div class="right-top-section-5">
            <div class="director-room">夏威夷</div>
            <div class="director-room">利物浦</div>
            <div class="director-room">新德里</div>
          </div>

          <!-- CEO -->
          <div class="right-top-section-6">
            CEO
          </div>
        </div>

        <!-- 右侧下部 B区 -->
        <div class="right-bottom-section">
          <!-- 左块 -->
          <div class="left-block">
            <!-- 层1: 女卫 -->
            <div class="layer1">
              <div class="air-conditioning-room">
                空调机房
              </div>
              <div class="women-toilet">
                <div class="toilet-left-area">
                  <img src="../images/toilet.png" title="男/女卫" class="stair" />
                  <span>男/女卫</span>
                </div>
                <div class="toilet-right-area">
                  <img src="../images/toilet.png" title="男卫" class="stair" />
                  <span>男卫</span>
                </div>
              </div>
              <div class="fire-stair">
                <div>
                  <img src="../images/stair.png" title="消防楼梯" class="stair" />
                  <div>消防楼梯</div>
                </div>
              </div>
            </div>

            <!-- 层2: 茶水间/机房 和 电梯厅/大厅 -->
            <div class="layer2">
              <div class="layer2-left">
                <div class="tea-room">
                  <div class="tea-room-left">机房</div>
                  <div class="tea-room-right">
                    <div class="xiuxian-top">
                      <img src="../images/leisure.png" title="沙发" class="leisure" style="width: 6rem;height: 6rem;" />
                    </div>
                    <div class="qiantai-area">
                      <span>前台</span>
                      <div style="width: 3.8rem;" :class="checkList.includes('Z') ? 'Zqu' : 'Zqu-hidden'">
                        <seat-tab class="flex-row" :seatList="sData.Z1" classTd="common_td4" />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="machine-room">
                  <div class="machine-room-left">储物间</div>
                  <div class="machine-room-right">
                    <img src="../images/leisure.png" title="沙发" class="leisure" style="width: 6rem;height: 6rem;" />
                  </div>
                </div>
              </div>
              <div class="layer2-right">
                <div class="elevator-hall-top">
                  电梯厅
                </div>
                <div class="main-entrance">
                  <span class="entrance-top"></span>
                  <span class="entrance-text">大厅大门</span>
                  <span class="entrance-bottom"></span>
                </div>
                <div class="elevator-hall-bottom">
                  <div class="elevator-area">
                    电梯厅
                  </div>
                  <div class="fire-stair-bottom">
                    <div>
                      <img src="../images/stair.png" title="消防楼梯" class="stair" />
                      <div>消防楼梯</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- 层3: 闸机 -->
            <div class="layer3">
              <div class="gate-left">
                闸机
              </div>
              <div class="gate-right">
                闸机
              </div>
            </div>

            <!-- 层4: 会议室 -->
            <div class="layer4">
              <div class="meeting-left">
                华盛顿
              </div>
              <div class="meeting-center">
                <div class="meeting-top">
                  <div class="meeting-room">比利时</div>
                  <div class="meeting-room">卢森堡</div>
                </div>
                <div class="meeting-middle">
                  <div class="meeting-room">吉隆坡</div>
                  <div class="meeting-room">西班牙</div>
                </div>
                <div class="meeting-bottom">
                  <div class="meeting-room">圣保罗</div>
                  <div class="meeting-room">慕尼黑</div>
                </div>
              </div>
              <div class="meeting-right">
                <div class="meeting-right-top" :class="checkList.includes('B') ? 'Bqu' : 'Bqu-hidden'">
                  <div style="width: 20rem;">
                    <seat-tab class="flex-row margin-bottom-1td  margin-top-1td" :seatList="sData.B10"
                      classTd="common_td" />
                  </div>
                  <div style="width: 20rem;" :class="checkList.includes('B') ? 'Bqu' : 'Bqu-hidden'">
                    <seat-tab class="flex-row margin-bottom-1td" :seatList="sData.B11" classTd="common_td" />
                  </div>
                </div>
                <div class="meeting-right-bottom">
                  <div class="ekroom">
                    贵宾办公室
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 右块 座位区域 -->
          <div class="right-block" :class="checkList.includes('B') ? 'Bqu' : 'Bqu-hidden'">
            <div style="width: 40rem;">
              <seat-tab class="flex-row margin-bottom-1td" :seatList="sData.B1" classTd="common_td" />
            </div>
            <div style="width: 35rem;">
              <seat-tab class="flex-row margin-bottom-1td" :seatList="sData.B2" classTd="common_td" />
            </div>
            <div style="width: 35rem;">
              <seat-tab class="flex-row margin-bottom-1td" :seatList="sData.B3" classTd="common_td" />
            </div>
            <div style="width: 30rem;">
              <seat-tab class="flex-row margin-bottom-1td" :seatList="sData.B4" classTd="common_td" />
            </div>
            <div style="width: 26rem;">
              <seat-tab class="flex-row margin-bottom-1td" :seatList="sData.B5" classTd="common_td" />
            </div>
            <div style="width: 25rem;">
              <seat-tab class="flex-row margin-bottom-1td" :seatList="sData.B6" classTd="common_td" />
            </div>
            <div style="width: 20rem;">
              <seat-tab class="flex-row margin-bottom-1td" :seatList="sData.B7" classTd="common_td" />
            </div>
            <div style="width: 20rem;">
              <seat-tab class="flex-row margin-bottom-1td" :seatList="sData.B8" classTd="common_td" />
            </div>
            <div style="width: 15rem;">
              <seat-tab class="flex-row margin-bottom-1td" :seatList="sData.B9" classTd="common_td" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import '../common.scss'
import seatTab from './seatTab.vue'
export default {
  components: {
    seatTab
  },
  data() {
    return {
      sData: {}
    }
  },
  props: {
    seatData: {
      type: Object,
      default() {
        return {}
      }
    },
    checkList: {
      type: Array,
      default() {
        return []
      }
    }
  },
  watch: {
    seatData: {
      handler: function(newVal) {
        this.sData = newVal
      },
      immediate: true,
      deep: true
    }
  }
}
</script>
<style lang="scss" scoped>
.sctz38Div {
  .main-layout {
    display: flex;
    gap: 3rem;
  }

  .sky-garden {
    width: 30rem;
    height: 18rem;
    border: 1px solid #000;
    margin-bottom: 4rem;
    position: relative;

    .cross-svg {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }

  .left-section {
    width: 21%;
  }
  .caiwu {
    width:30rem;
    border: 1px solid #000;
  }

  .right-section {
    width: 79%;
  }

  .right-top-section {
    display: flex;
    margin-bottom: 4rem;
    height: 19.6rem;
  }

  .right-top-section-1 {
    width: 12%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border: 1px solid #000;

    img {
      margin-bottom: 0.5rem;
    }
  }

  .right-top-section-2 {
    width: 12%;
    height: 100%;
    display: flex;
    flex-direction: column;
    border: 1px solid #000;
    border-left: none;

    .storage-room,
    .geneva-room {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .storage-room {
      border-bottom: 1px solid #000;
    }
  }

  .right-top-section-3 {
    width: 12%;
    height: 100%;
    display: flex;
    flex-direction: column;
    border: 1px solid #000;
    border-left: none;

    .director-room {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
      font-size: 0.9rem;
      border-bottom: 1px solid #000;

      &:last-child {
        border-bottom: none;
      }
    }
  }

  .right-top-section-4 {
    flex: 1;
    height: 100%;
    display: flex;
    justify-content: center;
    border-top: 1px solid #000;
    padding: 0 1rem;
    position: relative;

    &::before,
    &::after {
      content: '';
      position: absolute;
      bottom: 0;
      width: 33.33%;
      border-bottom: 1px solid #000;
    }

    &::before {
      left: 0;
    }

    &::after {
      right: 0;
    }
  }

  .right-top-section-5 {
    width: 12%;
    height: 100%;
    display: flex;
    flex-direction: column;
    border: 1px solid #000;

    .director-room {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
      font-size: 0.9rem;
      border-bottom: 1px solid #000;

      &:last-child {
        border-bottom: none;
      }
    }
  }

  .right-top-section-6 {
    width: 18%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #000;
    border-left: none;
  }

  .c-seat-column {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    flex: 1;
  }

  .right-top-section-4 > .c-seat-column:first-child {
    display: flex;
    justify-content: center;
    align-items: flex-end;
    padding-right: 2rem;
  }

  .right-top-section-4 > .c-seat-column:last-child {
    display: flex;
    justify-content: center;
    align-items: flex-start;
    padding-left: 2rem;
  }

  .director-office-middle {
    width: 2.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    font-size: 0.9rem;
    line-height: 1.5;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }

  .right-bottom-section {
    display: flex;
    gap: 5rem;
  }

  .left-block {
    flex: 1;
    display: flex;
    flex-direction: column;
  }

  .layer1 {
    height: 14rem;
    display: flex;
    border: 1px solid #000;
    align-items: center;
    justify-content: center;
  }

  .air-conditioning-room,
  .fire-stair {
    flex: 1;
    height: 14rem;
    display: flex;
    align-items: center;
    justify-content: center;
    border-right: 1px solid #000;
  }

  .fire-stair {
    border-right: none;
    border-left: 1px solid #000;
  }

  .women-toilet {
    width: 42rem;
    height: 14rem;
    display: flex;
  }

  .toilet-left-area,
  .toilet-right-area {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;

    .stair {
      width: 4rem;
      height: 4rem;
    }
  }

  .toilet-left-area {
    border-right: 1px solid #000;
  }

  .fire-stair {
    .stair {
      width: 4rem;
      height: 4rem;
    }
  }

  .layer2 {
    height: 22rem;
    display: flex;
    // gap: 2rem;
    justify-content: space-between;
  }

  .layer2-left {
    width: 35rem;
    display: flex;
    flex-direction: column;
  }

  .tea-room {
    height: 15rem;
    display: flex;

    .tea-room-left {
      width: 50%;
      height: 15rem;
      border-right: 1px solid #000;
      border-left: 1px solid #000;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .tea-room-right {
      width: 50%;
      height: 15rem;
      display: flex;
      flex-direction: column;
      position: relative;

      .xiuxian-top {
        position: absolute;
        top: 0;
        right: 0;
      }

      .qiantai-area {
        position: absolute;
        bottom: 2rem;
        left: 50%;
        transform: translateX(-50%);
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 0.5rem;
      }
    }
  }

  .machine-room {
    height: 7rem;
    // border: 1px solid #000;
    display: flex;

    .machine-room-left {
      width: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      border: 1px solid #000;
    }

    .machine-room-right {
      width: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      border: none;
    }
  }

  .layer2-right {
    width: 31rem;
    display: flex;
    flex-direction: column;
  }

  .elevator-hall-top {
    height: 11rem;
    border-left: 1px solid #000;
    border-right: 1px solid #000;
    border-bottom: 1px solid #000;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .main-entrance {
    height: 5rem;
    display: flex;
    // align-items: center;
    flex-direction: column;
    position: relative;
  }

  .entrance-top,
  .entrance-bottom {
    border-left: 1px solid #000;
  }

  .entrance-top,
  .entrance-bottom {
    height: 1.5rem;
  }

  .entrance-text {
    height: 2rem;
  }

  .entrance-text {
    display: flex;
    align-items: center;
  }

  .elevator-hall-bottom {
    height: 12rem;
    border: 1px solid #000;
    display: flex;
  }

  .elevator-area {
    width: 70%;
    display: flex;
    align-items: center;
    justify-content: center;
    border-right: 1px solid #000;
  }

  .fire-stair-bottom {
    width: 30%;
    display: flex;
    align-items: center;
    justify-content: center;

    .stair {
      width: 4rem;
      height: 4rem;
    }
  }

  .layer3 {
    height: 6rem;
    display: flex;
    gap: 2rem;
  }

  .gate-left,
  .gate-right {
    flex: 1;
    display: flex;
    align-items: center;
    padding: 0.5rem;

  }

  .gate-left {
    justify-content: left;
    border-left: 1px solid #000;
  }

  .gate-right {
    justify-content: right;
    border-right: 1px solid #000;
  }

  .layer4 {
    height: 20.5rem;
    display: flex;
  }

  .meeting-left {
    width: 15%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border: 1px solid #000;
  }

  .meeting-center {
    width: 61%;
    display: flex;
    flex-direction: column;
  }

  .meeting-top,
  .meeting-middle,
  .meeting-bottom {
    flex: 1;
    display: flex;
  }

  .meeting-top,
  .meeting-middle,
  .meeting-bottom {
    gap: 4rem;
  }

  .meeting-room {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #000;
  }

  .meeting-left .meeting-room:first-child,
  .meeting-right .meeting-room:first-child {
    border-bottom: none;
  }

  .meeting-top .meeting-room:first-child {
    border-left: none;
    border-bottom: none;
  }

  .meeting-middle .meeting-room:first-child {
    border-left: none;
    border-bottom: none;
  }

  .meeting-bottom .meeting-room:first-child {
    border-left: none;
  }

  .meeting-top .meeting-room:last-child {
    border-right: none;
    border-bottom: none;
  }

  .meeting-middle .meeting-room:last-child {
    border-right: none;
    border-bottom: none;
  }

  .meeting-bottom .meeting-room:last-child {
    border-right: none;
  }

  .meeting-right {
    width: 24%;
    display: flex;
    flex-direction: column;
    border-top: 1px solid #000;
    border-left: 1px solid #000;

    .meeting-right-top {
      height: 63%;
    }

    .meeting-right-bottom {
      flex: 1;
      position: relative;

      .ekroom {
        position: absolute;
        top: 0;
        left: 0;
        width: 30.5rem;
        height: 100%;
        border: 1px solid #000;
        border-left: none;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }

  .right-block {
    width: 40rem;
    display: flex;
    flex-direction: column;
  }
}

.Aqu {
  .common_td {
    background-color: rgb(219, 229, 241);
  }
}

.Bqu {

  .common_td,
  .common_td4 {
    background-color: rgb(242, 220, 219);
  }
}

.Cqu {

  .common_td,
  .common_td4 {
    background-color: rgb(229, 224, 236);
  }
}

.Aqu-hidden,
.Bqu-hidden,
.Cqu-hidden {
  pointer-events: none;
  opacity: 0.0;
}

.flex-row {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}

.margin-bottom-1td {
  margin-bottom: 2rem;
}
</style>
